import { Button, Icon } from "semantic-ui-react";

import { Can } from "components";
import "modules/FactoryExportsDashboard/components/FactoryExportsToolbar/FactoryExportsToolbar.scss";

type FactoryExportsToolbarProps = {
  onOpenAddExportModal: () => void;
};

export const FactoryExportsToolbar = ({ onOpenAddExportModal }: FactoryExportsToolbarProps) => (
  <Can I="create" the="factory-export">
    <div className="FactoryExportsToolbar">
      <Button basic icon className="add-btn" onClick={onOpenAddExportModal}>
        <Icon className="plus" />
      </Button>
    </div>
  </Can>
);
